export default __webpack_public_path__ + "static/media/logo.489b4c96.png";